import { z } from 'zod';
export const competitionSeasonScopeSchema = z.object({
    competitionCode: z.string().trim().min(1),
    competitionLabel: z.string().trim().min(1),
    season: z.number().int().positive(),
    seasonLabel: z.string().trim().min(1),
    shortLabel: z.string().trim().min(1),
    format: z.enum(['tournament', 'domestic_league', 'hybrid_cup']),
    enabled: z.boolean(),
    capabilities: z.object({
        fixtures: z.boolean(),
        markets: z.boolean(),
        completedReview: z.boolean(),
        automation: z.boolean(),
    }),
    availabilityText: z.string().trim().min(1),
});
export const competitionSeasonScopesResponseSchema = z.object({
    scopes: z.array(competitionSeasonScopeSchema),
});
